import AlphaHelpers from '../../abstracts/classes/alpha-helpers'
import AlphaModule from '../../abstracts/classes/alpha-module'

export default class NcsWrapper extends AlphaModule {
  constructor(...args) {
    super(...args)

    this._ncsState = AlphaHelpers.getLibStates().stateNone
  }

  getName() {
    return 'ncsWrapper'
  }

  getDefaultConfig() {
    return {
      ncsSelector: '[data-ncs]'
    }
  }

  _onLoad() {
    super._onLoad()

    this.initNcs()
  }

  _hasAnyNcsElement() {
    return document.querySelector(this.getConfig().ncsSelector) !== null
  }

  _shouldLoadNcs() {
    const stateNone = AlphaHelpers.getLibStates().stateNone === this.getNcsState()
    if (stateNone && typeof window.ncs !== 'undefined') {
      this._ncsState = AlphaHelpers.getLibStates().stateLoaded
      return false
    }

    return stateNone && this._hasAnyNcsElement()
  }

  async _loadNcsAsync() {
    // mark Classes Switcher as loading to ensure we don't it multiple times
    this._ncsState = AlphaHelpers.getLibStates().stateLoading

    await import(/* webpackChunkName: "ncs" */ '@nematis/classes-switcher/assets/js/core/ncs')
      .then(({
        default: ncsClass
      }) => {
        // eslint-disable-next-line new-cap
        window.ncs = new ncsClass()
      })

    // mark Classes Switcher as loaded and inform other components
    this._ncsState = AlphaHelpers.getLibStates().stateLoaded

    this.dispatchEvent('ncs.loaded', {
      aos: this.getNcs()
    })
  }

  getNcs() {
    return window.ncs
  }

  getNcsState(toString = false) {
    const ncsState = this._ncsState

    return toString ? AlphaHelpers.getLibStateString(ncsState) : ncsState
  }

  initNcs() {
    // potentially load Classes Switcher
    if (this._shouldLoadNcs()) {
      this._loadNcsAsync()
    }
  }
}
